export const TPPRoutes = {
    ROOT: "/tpp",
    DETAILS: "/tpp/details",
    SIGNING: "/tpp/signing",
    SUCCESS: "/tpp/success"
};


// WEBPACK FOOTER //
// ./src/components/tpp/TPPRoutes.tsx